import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = { class: "timepicker-icon" }
const _hoisted_3 = {
  ref: "timeSelectionRef",
  class: "time-selection"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createElementBlock("div", {
    class: "d-flex time-picker",
    "data-testid": `${_ctx.testid}-time-picker`
  }, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "picker-header" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_icon, { alt: "Uhr" }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(" mdi-clock ", -1)
        ]))]),
        _: 1
      })
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "time-label" }, [
      _createElementVNode("span", { class: "hour-label" }, "HH"),
      _createElementVNode("span", { class: "divider" }),
      _createElementVNode("span", { class: "minute-label" }, "MM")
    ], -1)),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_v_list, {
        dense: "",
        class: "hour-list",
        "data-testid": `${_ctx.testid}-time-picker-hour`
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allowedHours, (hour) => {
            return (_openBlock(), _createBlock(_component_v_list_item, {
              key: 'h-' + hour.value,
              class: _normalizeClass({
            selected: hour.value === _ctx.selectedHour,
            disabled: hour.disabled,
            'current-time': _ctx.isToday && hour.value === _ctx.currentHour,
          }),
              onClick: ($event: any) => (!hour.disabled && _ctx.selectHour(hour.value))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(hour.text), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["class", "onClick"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["data-testid"]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "divider" }, null, -1)),
      _createVNode(_component_v_list, {
        dense: "",
        class: "minute-list",
        "data-testid": `${_ctx.testid}-time-picker-minute`
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allowedMinutes, (minute) => {
            return (_openBlock(), _createBlock(_component_v_list_item, {
              key: 'm-' + minute.value,
              class: _normalizeClass({
            selected: minute.value === _ctx.selectedMinute,
            disabled: minute.disabled,
            'current-time': _ctx.isToday && _ctx.selectedHour === _ctx.currentHour && minute.value === _ctx.roundedCurrentMinute,
          }),
              onClick: ($event: any) => (!minute.disabled && _ctx.selectMinute(minute.value))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(minute.text), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["class", "onClick"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["data-testid"])
    ], 512)
  ], 8, _hoisted_1))
}